import React from 'react';
import SpinnerSymulator from './SpinnerSymulator';
import './Loader.scss';


const Loader = ({ active = true, global = false, text = 'Ładowanie...', className = '' }) => {
    const classes = ['loader'];
    if (className)
        classes.push(className);
    if (active)
        classes.push('active')
    if (global)
        classes.push('global')
    return (
        <div className={classes.join(' ')}>
            <SpinnerSymulator />
            <p className="loader__text">{text}</p>
        </div>
    );
}

export default Loader;